module.exports = __webpack_public_path__ + "img/chadle_adv_06.1abb1667.png";